import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import gymConfigService from '../services/gymConfigService';

const GymConfigContext = createContext(null);

export const GymConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    nombre: 'PichTraining',
    slogan: '',
    logo: null,
    email: '',
    telefono: '',
    direccion: '',
    instagram: '',
    whatsapp: '',
  });

  const loadConfig = useCallback(async () => {
    try {
      const data = await gymConfigService.getConfig();
      setConfig(data);
    } catch {
      // Falla silenciosa: se usan los valores por defecto
    }
  }, []);

  useEffect(() => {
    loadConfig();
  }, [loadConfig]);

  return (
    <GymConfigContext.Provider value={{ config, reloadConfig: loadConfig }}>
      {children}
    </GymConfigContext.Provider>
  );
};

export const useGymConfig = () => useContext(GymConfigContext);
